module.exports = __webpack_public_path__ + "static/img/Rectangle 12.05b0212.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Rectangle 12.png
// module id = zH1i
// module chunks = 1